import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import { BodyM, Caption } from 'components/Typography/Typography';
import CardIcon from 'components/Card/CardIcon';
import UserIcon from 'components/UserIcon/UserIcon';
import { SingleAccountManager as SingleManager } from 'utils/api/models/users/singleAccountManager';
import GridItem from 'components/Grid/GridItem';
import { translate } from 'components/Translation';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleAccountManagerProps {
	manager: SingleManager;
}

const SingleAccountManager = ({ manager }: ISingleAccountManagerProps) => {
	const classes = useStyles();
	return (
		<GridItem xs={12} sm={6} md={4} lg={3}>
			<div className={classes.singleAccountManagerWrapper}>
				<div>
					<CardIcon color="warning" size="xs">
						<UserIcon type="ADMIN" />
					</CardIcon>
				</div>
				<div>
					<div className={classes.managerNameWrapper}>
						<BodyM disableMargin>{manager.fullName}</BodyM>
					</div>
					<div className={classes.accountTypeWrapper}>
						<Caption color="disabled-light" disableMargin>
							{manager.jobTitle.toUpperCase()}
						</Caption>
					</div>
					<Caption color="secondary-light" disableMargin>
						{translate('account.details.account.manager.email', manager.emailAddress)}
					</Caption>
					<Caption color="secondary-light" disableMargin>
						{translate('account.details.account.manager.phone', manager.mobileTelephone)}
					</Caption>
				</div>
			</div>
		</GridItem>
	);
};

export default SingleAccountManager;
